module.exports = __webpack_public_path__ + "0f8c55ddc8cb027c3eedc084f7208dc4.jpg";